import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { useRootStore } from '../../../loaders/useRootStore';
import { useGetCategoriesLink } from '../../routes';
import { useNavigate } from 'react-router-dom';
import styles from './GameVersionSelector.module.sass';
import { ClaimType } from '@yakoffice/publisher-types';
import { ButtonGroup, Form } from 'react-bootstrap';


interface PropsType {
    [key: string]: any,

    selectedGameVersion?: IGameVersion,
    handleGameVersionChange?: (targetGameVersion: IGameVersion) => void,
}

export const GameVersionSelectorAsSelection: FC<PropsType> = observer(({
                                                                           selectedGameVersion,
                                                                           handleGameVersionChange,
                                                                           className
                                                                       }) => {
    const rootStore = useRootStore();
    const navigate = useNavigate();
    const getCategoriesLink = useGetCategoriesLink();

    const onGameVersionChange = (targetGameVersion: string) => {

        const gameVersion = rootStore.gameVersionStore.gameVersions.find(gameVersion => gameVersion.id === Number.parseInt(targetGameVersion));

        if (gameVersion) {

            if (gameVersion.name.toLowerCase() === 'staticdata') {
                const devGameEnvironmentId = rootStore.gameEnvironmentsStore.gameEnvironments.find(gameEnvironment => gameEnvironment.name.toLowerCase() === 'dev')?.id;
                rootStore.gameEnvironmentsStore.setCurrentGameEnvironment(devGameEnvironmentId !== undefined ? devGameEnvironmentId : rootStore.gameEnvironmentsStore.getCurrentGameEnvironment().id);
            }

            handleGameVersionChange
                ? handleGameVersionChange(gameVersion)
                : navigate(getCategoriesLink({ gameVersionId: gameVersion.id }));
        }
    };

    const selectedGameVersionOrDefault = rootStore.gameVersionStore.getCurrentGameVersion().id;


    return rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.ViewAllGameVersions)
        ?
        <Form.Select align="end"
                     onChange={(e) => onGameVersionChange(e.target.value)}
                     as={ButtonGroup}
                     defaultValue={selectedGameVersionOrDefault}
                     className={`${styles.gameEnvSelector} ${className ?? ''}`}>
            {rootStore.gameVersionStore.gameVersions
                .filter(gameVersion => !gameVersion.isArchived())
                .map(gv => {
                    return <option key={gv.id} value={gv.id}>{gv.name}</option>;
                })}
        </Form.Select>
        : null;
});

